export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}

// Follow-up dates are wall-clock dates in Asia/Kolkata stored as a UTC instant
// at local midnight. Render and compare them in that zone so a "20 Jun"
// follow-up never drifts to the 19th/21st in another timezone.
const KOLKATA_DATE = new Intl.DateTimeFormat("en-CA", {
  timeZone: "Asia/Kolkata",
});

export function formatFollowUpDate(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString(undefined, {
    timeZone: "Asia/Kolkata",
    year: "numeric",
    month: "short",
    day: "2-digit",
  });
}

// YYYY-MM-DD (Asia/Kolkata) — the value/min for a <input type="date"> picker.
export function toKolkataDateInput(iso: string | null | undefined): string {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return KOLKATA_DATE.format(d);
}

// Today as YYYY-MM-DD (Asia/Kolkata) — the `min` for a follow-up date picker.
export function todayKolkataInput(): string {
  return KOLKATA_DATE.format(new Date());
}

// True when the follow-up's local date is strictly before today (Kolkata).
export function isFollowUpOverdue(iso: string | null | undefined): boolean {
  if (!iso) return false;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return false;
  return KOLKATA_DATE.format(d) < KOLKATA_DATE.format(new Date());
}

export function formatRelative(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  const diffMs = d.getTime() - Date.now();
  const abs = Math.abs(diffMs);
  const units: Array<{ ms: number; name: Intl.RelativeTimeFormatUnit }> = [
    { ms: 365 * 24 * 60 * 60 * 1000, name: "year" },
    { ms: 30 * 24 * 60 * 60 * 1000, name: "month" },
    { ms: 7 * 24 * 60 * 60 * 1000, name: "week" },
    { ms: 24 * 60 * 60 * 1000, name: "day" },
    { ms: 60 * 60 * 1000, name: "hour" },
    { ms: 60 * 1000, name: "minute" },
  ];
  for (const u of units) {
    if (abs >= u.ms) {
      const v = Math.round(diffMs / u.ms);
      return new Intl.RelativeTimeFormat(undefined, { numeric: "auto" }).format(v, u.name);
    }
  }
  return "just now";
}
